'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactisModal = require('reactis-modal');

var _components = {
	_$ActionButton: {
		displayName: 'ActionButton'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var ActionButton = (function (_Component) {
	_inherits(ActionButton, _Component);

	function ActionButton() {
		_classCallCheck(this, _ActionButton);

		_Component.apply(this, arguments);
	}

	ActionButton.prototype.handleClick = function handleClick() {
		if (!this.props.disabled) {
			this.props.onClick();
		} else {
			if (this.props.onDisabledClick) {
				this.props.onDisabledClick();
			}
			if (this.props.alert) {
				var _alert = new _reactisModal.AlertWindow('Oprávnění', this.props.alert);
				_alert.show(this.context.store.dispatch);
			}
		}
	};

	ActionButton.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(
			_reactBootstrap.Button,
			{ bsStyle: this.props.bsStyle,
				className: _classnames2['default']({ 'input-group': true, disabled: this.props.disabled }),
				onClick: function () {
					return _this.handleClick();
				} },
			_react2['default'].createElement('i', { className: this.props.icon + ' position-left' }),
			this.props.children
		);
	};

	_createClass(ActionButton, null, [{
		key: 'defaultProps',
		value: {
			alert: 'Nemáte oprávnění akci provést!'
		},
		enumerable: true
	}, {
		key: 'contextTypes',
		value: {
			store: _react2['default'].PropTypes.object
		},
		enumerable: true
	}]);

	var _ActionButton = ActionButton;
	ActionButton = _wrapComponent('_$ActionButton')(ActionButton) || ActionButton;
	return ActionButton;
})(_Component2['default']);

exports['default'] = ActionButton;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ActionButton.js
 ** module id = 242
 ** module chunks = 2
 **/